import React, { useEffect, useState } from 'react';
import { Row, Container, Col } from 'react-bootstrap';

import Navbar from '../Navbar/NavBar';
import Loader from '../Shared/Loader';
import TableTeam from './TableTeams';
import { SEASON_FILTER } from '../../config/constants';
import SimpleSelector from '../Shared/Filters/SimpleSelector';
import { useDataTeamsDispatch, useFiltersState } from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';

export default () => {

  const { specificScope } = useRouter();
  const { 
    [SEASON_FILTER.filterKey]: filterSeasonData 
  } = useFiltersState(specificScope, SEASON_FILTER.filterKey);
  const { getTeamsStandings } = useDataTeamsDispatch();

  const [conference, setConference] = useState(false);
  const [showFilter, setShowFilter] = useState(-1);

  useEffect(() => {
    getTeamsStandings();
  }, [filterSeasonData]);

  const close = () => setShowFilter(-1);

  return (
    <>
      <Navbar />
      <Container className="container-00">
        <h4 className="h-t">Teams</h4>
        <Row>
          <Col lg={12} xs={12}>
            <div className="head-filters">
              <SimpleSelector
                show={showFilter === 0}
                close={close}
                open={() => setShowFilter(0)}
                type={SEASON_FILTER}
                urlPersistent
              />
              <div className="switch-input-div">
                <label className="title-s">AFC on Top</label>
                <input
                  type="checkbox"
                  id="id-name--1"
                  name="set-name"
                  className="switch-input"
                  checked={conference}
                  onChange={() => setConference(!conference)}
                />
                <label htmlFor="id-name--1" className="switch-label" />
              </div>
            </div>
            <div className="teams-body">
              <Loader>
                <TableTeam conference={conference} />
              </Loader>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
